import { Link } from "react-router-dom";
import { Show } from "@clerk/react";
import { LockKeyhole } from "lucide-react";

export const signInHref = () => `/sign-in?redirect_url=${encodeURIComponent(window.location.href)}`;

export const SignInLink = ({ className, testId, children }) => (
  <Link to={signInHref()} className={className} data-testid={testId}>{children}</Link>
);

export function PageHead({ icon: Icon, title, sub }) {
  return (
    <div className="mb-8 flex items-start gap-4">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-hc-mint"><Icon className="h-6 w-6 text-hc-green" /></span>
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-hc-ink sm:text-4xl">{title}</h1>
        {sub && <p className="mt-1 text-hc-slate">{sub}</p>}
      </div>
    </div>
  );
}

export function RequireSignIn({ title, testId, children }) {
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out">
        <div className="container-x grid min-h-[50vh] place-items-center py-16 text-center" data-testid={testId}>
          <div className="card-hc max-w-md p-8">
            <LockKeyhole className="mx-auto h-10 w-10 text-hc-gold" />
            <h1 className="mt-4 font-display text-2xl font-bold text-hc-ink">{title}</h1>
            <p className="mt-2 text-sm text-hc-slate">Please sign in to continue.</p>
            <SignInLink className="btn-primary mt-6" testId={`${testId}-btn`}>Sign in with mobile number</SignInLink>
          </div>
        </div>
      </Show>
    </>
  );
}
